import { useEffect } from "react";

export const SITE = "https://guatemalanspirit.it";

export default function useSeo({ title, description, jsonLd, path }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      document.head.querySelector('meta[property="og:title"]')?.setAttribute("content", title);
      document.head.querySelector('meta[name="twitter:title"]')?.setAttribute("content", title);
    }
    if (description) {
      let m = document.head.querySelector('meta[name="description"]');
      if (!m) { m = document.createElement("meta"); m.setAttribute("name", "description"); document.head.appendChild(m); }
      m.setAttribute("content", description);
      document.head.querySelector('meta[property="og:description"]')?.setAttribute("content", description);
      document.head.querySelector('meta[name="twitter:description"]')?.setAttribute("content", description);
    }
    if (path) document.head.querySelector('link[rel="canonical"]')?.setAttribute("href", SITE + path);
    document.head.querySelectorAll('script[data-seo="page"]').forEach((s) => s.remove());
    (jsonLd || []).forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json"; s.dataset.seo = "page"; s.text = JSON.stringify(obj);
      document.head.appendChild(s);
    });
    return () => document.head.querySelectorAll('script[data-seo="page"]').forEach((s) => s.remove());
  }, [title, description, path, JSON.stringify(jsonLd)]); // eslint-disable-line react-hooks/exhaustive-deps
}
